import { module } from 'modujs'
import modularLoad from 'modularload'
import { resetLazyloadCallbacks, triggerLazyloadCallbacks } from '../utils/image'

export default class extends module {
    constructor(m) {
        super(m)

        this.events = {
            click: {
                button: 'onClick',
            }
        }
    }

    init() {
        this.load = new modularLoad({
            enterDelay: 750,
            transitions: {
                listing: {
                    loadingClass: 'is-loading',
                    enterDelay: 250,
                },
            }
        })

        this.load.on('loaded', (transition, oldContainer, newContainer) => {
            this.call('destroy', oldContainer, 'app')
            this.call('update', newContainer, 'app')
            this.call('checkParams', null, 'CookieConsent')

            if (transition === 'listing') {
                this.call('addScrollElements', newContainer, 'Scroll')

                const $loadContainer = document.getElementById('load-container')
                $loadContainer?.removeAttribute('aria-busy', true)

                setTimeout(() => {
                    this.call('scrollTo', { target: $loadContainer }, 'Scroll')
                    $loadContainer.querySelector('a, button, input')?.focus()
                }, 100);
            }

            /**
             * Trigger lazyload
             */
            triggerLazyloadCallbacks()
        })


        this.load.on('loading', (transition, oldContainer, x) => {
            resetLazyloadCallbacks()

            if(transition === 'listing') {
                this.call('removeScrollElements', oldContainer, 'Scroll')

                const $loadContainer = document.getElementById('load-container')
                $loadContainer?.setAttribute('aria-busy', true)
            }
        })
    }

    onClick(e) {
        this.goTo({ url: e.curTarget.dataset.url })
    }

    goTo({ url, transition = 'listing'}) {
        this.load?.goTo(url, transition)
    }
}
